// extracted by css-extract-rspack-plugin
export default {"appStoreBtn":"_fb194004"};